<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifb-business-name-input [fc]="form.get('name')" baseFilterItem class="mat-form-field"></ifb-business-name-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput multiple formControlName="statuses" placeholder="Status">
        <mat-option *ngFor="let s of entityStatuses" [value]="s.value">{{ s.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('statuses').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('statuses').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifc-filter-param-date-range-input
      [fc]="form.get('createdOn')"
      baseFilterItem
      [label]="'Created on'"
      (rangeSelected)="createdDateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnStart')" [label]="'Created date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnEnd')" [label]="'Created date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ifb-entity-number-input [fc]="form.get('number')" baseFilterItem></ifb-entity-number-input>
    <ifb-entity-ein-input [fc]="form.get('ein')" baseFilterItem></ifb-entity-ein-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Bank link status</mat-label>
      <mat-select formControlName="bankLinkStatus" placeholder="All">
        <mat-option [value]="">All</mat-option>
        <mat-option *ngFor="let option of bankLinkStatusOptions" [value]="option.value">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Bank link attempted</mat-label>
      <mat-select formControlName="bankLinkAttempted" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option [value]="'true'">Yes</mat-option>
        <mat-option [value]="'false'">No</mat-option>
      </mat-select>
    </mat-form-field>

    <ifc-filter-param-date-range-input
      [fc]="form.get('lastLinkingAttemptDate')"
      baseFilterItem
      [label]="'Last linking attempt date'"
      (rangeSelected)="lastLinkingAttemptDateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Verification status</mat-label>
      <mat-select formControlName="isVerified" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option [value]="'false'">Unverified</mat-option>
        <mat-option [value]="'true'">Verified</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="form.get('lastLinkingAttemptDate').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('lastLinkingAttemptDateFrom')"
        [label]="'Last linking attempt date from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker
        [fc]="form.get('lastLinkingAttemptDateTo')"
        [label]="'Last linking attempt date to'"
        baseFilterItem
      ></ifc-datepicker>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
`
